module.exports = __webpack_public_path__ + "img/alipay.020806f3.svg";